import { authHeader } from "../util/auth-header";
import http from "../util/http-common";

export class SysMaintainenceService {
  static async getAllCountries() {
    return http.get("/cfadminsysmaintain/api/v1/countries",{ headers: await authHeader()});
  }

  static async getAllLanguages() {
    return http.get("/cfadminsysmaintain/api/v1/languages",{ headers: await authHeader()});
  }

  static async getAllCountryLanguages() {
    return http.get("/cfadminsysmaintain/api/v1/countries-languages",{ headers: await authHeader()});
  }

}

export default SysMaintainenceService;